/* eslint-disable max-len */
import React from 'react';

export const AddImageIcon = props => (
  <svg width="72" height="72" viewBox="0 0 72 72" {...props}>
    <path
      fillRule="evenodd"
      d="M45 15l6.064 9H63v36H9V24h12.008L27 15h18zm-1.596 3H28.607l-5.992 9H12v30h48V27H49.468l-6.064-9zM36 27c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm0 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z"
      opacity=".6"
    />
  </svg>
);
